// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__hASaH","colCheckbox":"styles_colCheckbox__1HHqP"};